// @flow
import PATHS, { HOUSEHOLD_PATHS } from 'constants/paths';
import { SectionSteps } from 'hooks/sectionsProgress/types';
import { FormattedMessage } from 'react-intl';
import { DESIGNATION_FIELD_NAMES } from 'pages/AffordaHousehold/AffordaHousehold.Designation.constants';
import { MINORS_RELATIONSHIP_FIELD_NAMES } from 'pages/AffordaHousehold/AffordaHousehold.MinorsRelationship.constants';
import { FULL_TIME_STUDENT_FIELD_NAMES } from 'pages/AffordaHousehold/AffordaHousehold.FullTimeStudent.constants';
import { ADDITIONAL_MINORS_FIELD_NAMES } from 'pages/AffordaHousehold/AffordaHousehold.AdditionalMinors.constants';

export const BUTTON_GROUP_SX = {
  flexWrap: 'wrap',
  width: '100%',
  '& > button': {
    width: { xs: 'calc(100% - 4px)', sm: 'calc(50% - 4px)' },
  },
};

// Only adding optional forms steps fields here. Can change this later if needed.
export const HOUSEHOLD_PATHS_TO_FIELD_NAMES_MAP = {
  [HOUSEHOLD_PATHS.DESIGNATION]: DESIGNATION_FIELD_NAMES,
  [HOUSEHOLD_PATHS.MINOR_RELATIONSHIP]: MINORS_RELATIONSHIP_FIELD_NAMES,
  [HOUSEHOLD_PATHS.FULL_TIME_STUDENT]: FULL_TIME_STUDENT_FIELD_NAMES,
  [HOUSEHOLD_PATHS.ADDITIONAL_MINORS]: ADDITIONAL_MINORS_FIELD_NAMES,
};

export const JOINT_CUSTODY_MAP = {
  no: {
    messageId: 'app.no',
    text: <FormattedMessage id="app.no" />,
    value: 'no',
  },
  yes50: {
    messageId: 'afforda.minorsRelationships.jointCustody.yes50',
    text: (
      <FormattedMessage id="afforda.minorsRelationships.jointCustody.yes50" />
    ),
    value: 'yes50',
  },
  yesLessThan50: {
    messageId: 'afforda.minorsRelationships.jointCustody.yesLessThan50',
    text: (
      <FormattedMessage id="afforda.minorsRelationships.jointCustody.yesLessThan50" />
    ),
    value: 'yesLessThan50',
  },
};

export const HOUSEHOLD_SECTION_NAMES = {
  MEMBERS: 'members',
  DESIGNATION: 'designation',
  MARITAL_STATUS: 'maritalStatus',
  MINOR_RELATIONSHIP: 'minorsRelationship',
  STUDENT_STATUS: 'studentStatus',
  FULL_TIME_STUDENT: 'fullTimeStudent',
  ADDITIONAL_MINORS: 'additionalMinors',
  LIVE_IN_AIDE: 'liveInAide',
  SUMMARY: 'summary',
  INVITE: 'invite',
};

export const HOUSEHOLD_STEPS = ({
  canInviteOthers,
  hasMoreThanOneAdult,
  hasMinors,
  hasPartTimeStudent,
  isStudentDisqualified,
}): SectionSteps => [
  {
    name: HOUSEHOLD_PATHS.MEMBERS,
    sectionName: HOUSEHOLD_SECTION_NAMES.MEMBERS,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.MEMBERS}`,
    required: true,
  },
  {
    name: HOUSEHOLD_PATHS.DESIGNATION,
    sectionName: HOUSEHOLD_SECTION_NAMES.DESIGNATION,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.DESIGNATION}`,
    required: hasMoreThanOneAdult,
    optional: true,
  },
  {
    name: HOUSEHOLD_PATHS.MARITAL_STATUS,
    sectionName: HOUSEHOLD_SECTION_NAMES.MARITAL_STATUS,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.MARITAL_STATUS}`,
    required: true,
  },
  {
    name: HOUSEHOLD_PATHS.MINOR_RELATIONSHIP,
    sectionName: HOUSEHOLD_SECTION_NAMES.MINOR_RELATIONSHIP,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.MINOR_RELATIONSHIP}`,
    required: hasMinors,
    optional: true,
  },
  {
    name: HOUSEHOLD_PATHS.STUDENT_STATUS,
    sectionName: HOUSEHOLD_SECTION_NAMES.STUDENT_STATUS,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.STUDENT_STATUS}`,
    required: true,
  },
  {
    name: HOUSEHOLD_PATHS.FULL_TIME_STUDENT,
    sectionName: HOUSEHOLD_SECTION_NAMES.FULL_TIME_STUDENT,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.FULL_TIME_STUDENT}`,
    required:
      typeof hasPartTimeStudent === 'boolean' ? !hasPartTimeStudent : undefined,
    optional: true,
  }, // Only required if there are NO part-time students
  {
    name: HOUSEHOLD_PATHS.ADDITIONAL_MINORS,
    sectionName: HOUSEHOLD_SECTION_NAMES.ADDITIONAL_MINORS,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.ADDITIONAL_MINORS}`,
    required: hasPartTimeStudent || isStudentDisqualified,
    optional: true,
  },
  {
    name: HOUSEHOLD_PATHS.SUMMARY,
    sectionName: HOUSEHOLD_SECTION_NAMES.SUMMARY,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.SUMMARY}`,
    required: true,
  },
  {
    name: HOUSEHOLD_PATHS.INVITE,
    sectionName: HOUSEHOLD_SECTION_NAMES.INVITE,
    path: `${PATHS.HOUSEHOLD}/${HOUSEHOLD_PATHS.INVITE}`,
    optional: true,
    required: canInviteOthers,
  },
];
